import { render, staticRenderFns } from "./summary-card-list.vue?vue&type=template&id=d28ebeb8&"
import script from "./summary-card-list.vue?vue&type=script&lang=js&"
export * from "./summary-card-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports